import template from './price-sale.jade';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';

const showRateFor = [
  'office',
  'building',
  'shoppingArea',
  'freeAppointmentObject',
  'garage',
  'industry',
  'warehouse',
  'commercialLand',
];

const unitTypeTexts = {
  squareMeter: 'м<sup>2</sup>',
  sotka: 'сотку',
  hectare: 'гектар',
};

export default angular.module('cian.addForm.priceSale', []).directive('cianAfPriceAndDealTermsPriceSale', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    '$scope',
    'categoryService',
    'adTooltipsService',
    'analyticsService',
    'deviceService',
    'popupService',
    function ($scope, categoryService, adTooltipsService, analyticsService, deviceService, popupService) {
      this.isMobile = deviceService.isMobile;
      this.modalHintTitle = 'Цена';
      this.tooltipText = '';
      this.ad.bargainTerms = this.ad.bargainTerms || {};

      const getTotalArea = () => {
        const { objectType } = categoryService.getInfoByCategory(this.ad.category);
        switch (objectType) {
          case 'building':
            return this.ad.building.totalArea || this.ad.totalArea;
          case 'commercialLand':
            return this.ad.land.area;
          default:
            return this.ad.totalArea;
        }
      };

      // если редактирование и тип цены за квадратный метр
      if (this.ad.id && this.ad.bargainTerms.priceType === 'squareMeter') {
        // мы ожидаем цену за все
        const totalArea = Number(getTotalArea());
        if (angular.isNumber(totalArea) && angular.isNumber(this.ad.bargainTerms.price)) {
          this.ad.bargainTerms.price = this.ad.bargainTerms.price * totalArea;
        }
      }
      this.ad.bargainTerms.priceType = 'all';

      this.getComputedRate = () => {
        const totalArea = getTotalArea();

        return this.ad.bargainTerms.price && totalArea ? this.ad.bargainTerms.price / totalArea : null;
      };

      this.isRateVisible = () => {
        const { objectType, dealType } = categoryService.getInfoByCategory(this.ad.category);

        return this.getComputedRate() && dealType === 'sale' && showRateFor.includes(objectType);
      };

      this.getRateTitle = () => {
        const { objectType } = categoryService.getInfoByCategory(this.ad.category);
        const unitType = objectType === 'commercialLand' ? this.ad.land && this.ad.land.areaUnitType : undefined;
        const text = unitTypeTexts[unitType] || unitTypeTexts.squareMeter;

        return `Ставка за ${text}`;
      };

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'bargainTerms.price',
        trackingLabel: 'price-sale-hint',
        popupService,
        isMobile: this.isMobile,
      });
    },
  ],
  controllerAs: 'priceSale',
  template,
})).name;
